import InvoicesPage from './InvoicesPage';

// Thin wrapper component to preserve existing route/import paths.
export default InvoicesPage;

